module.exports = __webpack_public_path__ + "assets/resstar3-1at2x.13228343e39943a5b9c05c494366b78b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/stars/resstar3-1at2x.png
// module id = 857
// module chunks = 0